import { BottomSheet } from "components/voc";
import { useState, useRef } from "react";
import { useQueryString } from "hooks";
import styled from "styled-components";
import IconSelect from "assets/images/icon_select.png";
import { privacies } from "data";

type PrivacySheetProps = {
  show: boolean;
  onClose: () => void;
};

const PrivacySheetWrapper = styled.div`
  .cont_header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 2rem 0;
    padding-bottom: 1rem;
    border-bottom: 0.2rem solid #000;
    line-height: 2.2rem;
  }
  /* .cont_header:first-child {
    z-index: 1;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    margin-top: 0;
    padding-top: 2rem;
    background-color: #fff;
  } */
  .cont_header .txt_title {
    font-weight: 700;
  }
  .cont_header .txt_title em {
    font-weight: 400;
    color: #e10032;
    font-size: 1.4rem;
  }
  .cont_header .txt_data {
    color: #e10032;
    font-weight: 700;
  }
  .cont_header .txt_noti {
    color: #8f8f8f;
    font-size: 1.4rem;
  }

  /* ===============================================================
개인정보처리방침 (privacy)
================================================================ */
  #wrap.subpage #content.page_privacy {
    padding: 0 3.1rem 8rem;
  }

  /* ===============================================================
개인정보처리방침 공통 템플릿
================================================================ */
  .c_template_privacy {
    margin-top: 2.6rem;
    font-family: "Pretendard";
    font-size: 1.4rem;
  }
  .c_template_privacy .txt,
  .c_template_privacy .txt_num {
    margin-top: 0.4rem;
    color: #000;
    font-size: 1.4rem;
    line-height: 2rem;
    letter-spacing: -0.014rem;
    word-break: keep-all;
  }
  .c_template_privacy > ol,
  .c_template_privacy > ul {
    margin: 2rem 0;
    color: #272731;
    font-size: 1.4rem;
    list-style: revert;
    list-style-position: inside;
    line-height: 2.4rem;
    letter-spacing: -0.014rem;
  }
  .c_template_privacy > ol.list_none,
  .c_template_privacy > ul.list_none {
    list-style: none;
  }
  .c_template_privacy hr {
    display: block;
    margin: 2rem 0;
    border: 1px solid #ececec;
  }
  .c_template_privacy .caption {
    color: #272731;
    font-size: 1.2rem;
    font-weight: 600;
    text-align: left;
  }
  .c_template_privacy .tbl {
    width: 100%;
    margin: 0.5rem 0 1rem;
    table-layout: fixed;
  }
  .c_template_privacy .tbl .caption {
    margin: 0 0 0.5rem;
  }
  .c_template_privacy .tbl th,
  .c_template_privacy .tbl td {
    color: #272731;
    font-size: 1.1rem;
    text-align: center;
  }
  .c_template_privacy .tbl th {
    padding: 1rem 1.2rem;
    background-color: rgba(0, 0, 0, 0.06);
    border-top: 1px solid #272731;
    font-weight: 600;
  }
  .c_template_privacy .tbl td {
    padding: 1.6rem 1.2rem;
    border-bottom: 1px solid #ececec;
    word-break: keep-all;
    white-space: pre-line;
  }
  .c_template_privacy .tbl td + td {
    border-left: 1px solid #ececec;
  }
  .c_template_privacy .tbl .align-base td {
    vertical-align: baseline;
  }
  .c_template_privacy strong.txt_title {
    color: #000;
    font-weight: 600;
  }
  .c_template_privacy strong.txt_title + .txt,
  .c_template_privacy strong.txt_title + .txt_num {
    margin-top: 0.4rem;
  }
  .c_template_privacy b.txt,
  .c_template_privacy b.txt_num {
    display: block;
    margin-top: 0.4rem;
    font-weight: 600;
  }
  .c_template_privacy b.txt ~ .list_sub,
  .c_template_privacy b.txt_num ~ .list_sub {
    margin-left: 2.3rem;
  }
  .c_template_privacy .txt_num {
    position: relative;
    padding-left: 1.3rem;
  }
  .c_template_privacy .txt_num .num {
    position: absolute;
    top: 0;
    left: 0;
  }
  .c_template_privacy .txt_num ~ .caption,
  .c_template_privacy .txt_num ~ .list_sub {
    margin: 0.6rem 0 0 1.3rem;
  }
  .c_template_privacy .txt_noti {
    font-size: 1.2rem;
    letter-spacing: -0.012rem;
    color: #000;
  }
  .c_template_privacy .txt_noti::before {
    content: "※ ";
  }
  .c_template_privacy .wrap_sub,
  .c_template_privacy .wrap_sub_detail {
    margin: 1rem 0 0;
  }
  .c_template_privacy .wrap_sub span.caption,
  .c_template_privacy .wrap_sub_detail span.caption {
    display: block;
    margin-top: 0.5rem;
    font-size: 1.3rem;
    letter-spacing: -0.013rem;
  }
  .c_template_privacy .wrap_sub .txt,
  .c_template_privacy .wrap_sub_detail .txt,
  .c_template_privacy .wrap_sub .txt_num,
  .c_template_privacy .wrap_sub_detail .txt_num {
    font-size: 1.2rem;
  }
  .c_template_privacy .wrap_sub .txt ~ .txt,
  .c_template_privacy .wrap_sub_detail .txt ~ .txt,
  .c_template_privacy .wrap_sub .txt_num ~ .txt,
  .c_template_privacy .wrap_sub_detail .txt_num ~ .txt,
  .c_template_privacy .wrap_sub .txt ~ .txt_num,
  .c_template_privacy .wrap_sub_detail .txt ~ .txt_num,
  .c_template_privacy .wrap_sub .txt_num ~ .txt_num,
  .c_template_privacy .wrap_sub_detail .txt_num ~ .txt_num {
    margin-top: 1rem;
  }
  .c_template_privacy .wrap_sub .txt_noti,
  .c_template_privacy .wrap_sub_detail .txt_noti {
    margin: 1rem 0;
  }
  .c_template_privacy .wrap_sub_detail {
    margin: 0.6rem 0 0;
  }
  .c_template_privacy .wrap_sub_detail .list_sub {
    font-size: 1.3rem;
  }
  .c_template_privacy .wrap_detail {
    margin: 2rem 0;
  }
  .c_template_privacy .list_sub {
    margin-top: 0.5rem;
    font-size: 1.4rem;
    color: #000;
    line-height: 2rem;
    letter-spacing: -0.014rem;
  }
  .c_template_privacy .list_sub li {
    position: relative;
    padding-left: 1rem;
  }
  .c_template_privacy .list_sub li::before {
    position: absolute;
    top: 0.8rem;
    left: 0;
    width: 0.3rem;
    height: 0.3rem;
    border-radius: 100%;
    background-color: #000;
    content: "";
  }
  .c_template_privacy .list_sub li b {
    font-weight: 600;
  }
  .c_template_privacy .list_disc dt {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 0.5rem;
    font-weight: 500;
    letter-spacing: -0.014rem;
  }
  .c_template_privacy .list_disc dt .num {
    display: inline-flex;
    justify-content: center;
    align-items: flex-end;
    width: 1.6rem;
    height: 1.6rem;
    margin: 1px 0.4rem 0 0;
    border-radius: 100%;
    border: 1px solid #272731;
    font-size: 1.1rem;
    font-weight: 500;
    letter-spacing: -0.011rem;
  }
  .c_template_privacy .list_disc dd {
    margin: 0.2rem 0 0 1.8rem;
    color: #272731;
    letter-spacing: -0.014rem;
  }
  .c_template_privacy .wrap_privacy_history {
    margin-top: 2rem;
  }
  .c_template_privacy .wrap_privacy_history .btn_view {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 1.4rem;
    color: #000;
    letter-spacing: -0.014rem;
  }
  .c_template_privacy .wrap_privacy_history .btn_view::after {
    display: inline-block;
    width: 1.8rem;
    height: 1.8rem;
    margin-left: 0.5rem;
    background: url(${IconSelect}) no-repeat 0 0;
    background-size: 1.8rem;
    vertical-align: middle;
    transition: 0.2s ease;
    transform: rotate(0);
    content: "";
  }
  .c_template_privacy .wrap_privacy_history .btn_view.-active::after {
    transform: rotate(-180deg);
  }
  .c_template_privacy .wrap_privacy_history .btn_view.-active + .list_sub {
    display: block;
  }
  .c_template_privacy .wrap_privacy_history .list_sub {
    display: none;
    margin-top: 1.1rem;
    line-height: 2.4rem;
    letter-spacing: -0.012rem;
  }
  .c_template_privacy .wrap_privacy_history .list_sub .-active {
    font-weight: 700;
  }
  .c_template_privacy .img_labeling {
    margin: 0 auto;
    display: block;
    max-width: 2.8rem;
  }
  .c_template_privacy .link {
    color: #1713ff;
    text-decoration: underline;
  }
`;

const PrivacySheet = ({ ...props }: PrivacySheetProps) => {
  const queryString = useQueryString(window.location.search);
  const query = queryString.json;
  const privacyindexQuery = query.privacy;
  let privacyIndex = privacies.length - 1;
  if (privacyindexQuery) {
    privacyIndex = privacyindexQuery;
    props.show = true;
  }

  const toggleHistory = (e: React.MouseEvent<HTMLButtonElement>) => {
    const history = e.currentTarget;
    history.classList.toggle("-active");
  };

  const handleRevision = (payload: number) => {
    privacySheetRef.current?.parentElement?.scrollTo({ top: 0, behavior: "smooth" });
    setState(payload);
    // window.open(`/block?privacy=${payload}`);
  };

  const [state, setState] = useState(privacyIndex);

  const privacySheetRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <BottomSheet title="개인정보 처리방침" fullPage {...props}>
        <PrivacySheetWrapper ref={privacySheetRef}>
          <div className="cont_header">
            {/* <strong className="txt_title">
              광고 참여 날짜 <em>(필수)</em>
            </strong> */}
          </div>
          <div className="cont_body">
            <div className="c_template_privacy">
              {privacies[state].content}
              <hr />
              <strong>부칙</strong>
              <p className="txt">(시행일) 본 개인정보처리방침은 {privacies[state].revision}부터 시행합니다.</p>
              <div className="wrap_privacy_history">
                <button type="button" className="btn_view" onClick={toggleHistory}>
                  이전 개인정보처리방침 보기
                </button>
                <ul className="list_sub">
                  {privacies.map((privacy, i) => (
                    <li key={i} onClick={() => handleRevision(i)} className={i === state ? "-active" : ""}>
                      개인정보처리방침 {i + 1}차 변경일 : {privacy.revision}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </PrivacySheetWrapper>
      </BottomSheet>
    </>
  );
};

export default PrivacySheet;
